import * as React from 'react';
import { Checkbox } from '@fluentui/react/lib/Checkbox';
import { CompactPeoplePicker, NormalPeoplePicker, PeoplePickerItem, ValidationState, } from '@fluentui/react/lib/Pickers';
import { people, mru } from '@fluentui/example-data';
import { useState } from 'react';
import { Label, Link, MessageBar, MessageBarType, TextField } from '@fluentui/react';
import { ActionButton } from '@fluentui/react/lib/Button';
import $ from 'jquery';
import Authentication from './Authentication';

const suggestionProps = {
    suggestionsHeaderText: 'Suggested People',
    mostRecentlyUsedHeaderText: 'Suggested Contacts',
    noResultsFoundText: 'No results found',
    loadingText: 'Loading',
    showRemoveButtons: true,
    suggestionsAvailableAlertText: 'People Picker Suggestions available',
    suggestionsContainerAriaLabel: 'Suggested contacts',
};

const checkboxStyles = {
    root: {
        marginTop: 10,
    },
};
function PeoplePicker() {
    const [delayResults, setDelayResults] = React.useState(false);
    const [isPickerDisabled, setIsPickerDisabled] = React.useState(false);
    const [mostRecentlyUsed, setMostRecentlyUsed] = React.useState(mru);
    const [peopleList, setPeopleList] = React.useState(peopleEmail);
    const [showErrorAuth, setShowErrorAuth] = React.useState(false);
    const [showPicker, setShowPicker] = React.useState(false);
    const [showStatements, setShowStatements] = React.useState(false);
    const [showErrors, setShowError] = React.useState(false);

    const apiUrl = process.env.API_URL;
    let peopleEmail
    let emailAddy
    const picker = React.useRef(null);
    
    const onFilterChanged = (filterText, currentPersonas, limitResults) => {
        if (filterText) {
            let filteredPersonas = filterPersonasByText(filterText);
            filteredPersonas = removeDuplicates(filteredPersonas, currentPersonas);
            filteredPersonas = limitResults ? filteredPersonas.slice(0, limitResults) : filteredPersonas;
            return filterPromise(filteredPersonas);
        }
        else {
            return [];
        }
    };
    const filterPersonasByText = (filterText) => {
        return peopleList.filter(item => doesTextStartWith(item.text, filterText));
    };
    const filterPromise = (personasToReturn) => {
        if (delayResults) {
            return convertResultsToPromise(personasToReturn);
        }
        else {
            return personasToReturn;
        }
    };
    const returnMostRecentlyUsed = (currentPersonas) => {
        const akey = localStorage.getItem('authKey');
        const url = apiUrl + '/api/Outlook';
        $.ajax({
            url: url,
            type: 'GET',
            headers: { "authkey": akey },
            success: function (response) {
                setPeopleList(response);
            },
            error: function (response) {
                console.log("error on get people list");
            }
        });
        return filterPromise(removeDuplicates(peopleList, currentPersonas));
    };
    const onRemoveSuggestion = (item) => {
        const indexPeopleList = peopleList.indexOf(item);
        const indexMostRecentlyUsed = mostRecentlyUsed.indexOf(item);
        if (indexPeopleList >= 0) {
            const newPeople = peopleList
                .slice(0, indexPeopleList)
                .concat(peopleList.slice(indexPeopleList + 1));
            setPeopleList(newPeople);
        }
        if (indexMostRecentlyUsed >= 0) {
            const newSuggestedPeople = mostRecentlyUsed
                .slice(0, indexMostRecentlyUsed)
                .concat(mostRecentlyUsed.slice(indexMostRecentlyUsed + 1));
            setMostRecentlyUsed(newSuggestedPeople);
        }
    };
    const renderItemWithSecondaryText = (props) => {
        const newProps = Object.assign(Object.assign({}, props), { item: Object.assign(Object.assign({}, props.item), { ValidationState: ValidationState.valid, showSecondaryText: true }) });
        return React.createElement(PeoplePickerItem, Object.assign({}, newProps));
    };
    const onDisabledButtonClick = () => {
        setIsPickerDisabled(!isPickerDisabled);
    };
    const onToggleDelayResultsChange = () => {
        setDelayResults(!delayResults);
    };
    const onToggleShowSecondaryText = () => {
        setShowSecondaryText(!showSecondaryText);
    };
    
    const getPeoplePickerItem = () => {  
        var emailList = document.getElementsByClassName("ms-TooltipHost");
        var eArr = [];
        for ( var i = 0; i < emailList.length; i++){
            eArr.push(emailList[i].childNodes[0].nodeValue);
        }
        console.log(eArr);
        emailAddy = eArr;
        console.log(emailAddy, "eAddy");
        setEmail(eArr);
    };
    
    React.useEffect(() => {
       const akey = localStorage.getItem('authKey');
        console.log(akey, "- akey");
       
       if (akey == null){
        setShowPicker(false);
       }
       else if (akey == "") {
        setShowPicker(false);
       }
       else{
        authUser();
        localStorage.setItem('authKey', akey);
       } 
    }, []);

    const authUser = () => {
        const akey = localStorage.getItem('authKey');

        if (akey == null) {
            var ak = $('#authKey').val();
            localStorage.setItem('authKey', ak);
        } 
        if (akey == "") {
            var ak = $('#authKey').val();
            localStorage.setItem('authKey', ak);
        }    
        
        const url = apiUrl + '/api/Outlook';
        $.ajax({
            url: url,
            type: 'GET',
            contentType: "application/json",
            headers: { "authkey": localStorage.getItem('authKey') },
            success: function (response) {
                setPeopleList(response);
                setShowPicker(true);
            },
            error: function (response) {
              setShowErrorAuth(true);   
              setTimeout(() => {
                setShowErrorAuth(false);
                }, 3000);             
            }
        });
    }
      
 var fromClient = Office.context.mailbox.item;
 
 const fromFiltClient = [{
    text: fromClient.from.displayName + ' (' + fromClient.from.emailAddress + ')',
    secondaryText: '',
    tertiaryText: '',
    optionalText: '',
    isValid: true,
    }];

let userToken
Office.context.mailbox.getUserIdentityTokenAsync(function (result) {
    if (result.status !== Office.AsyncResultStatus.Succeeded) {
        console.error(`Token retrieval failed with message: ${result.error.message}`);
    } else {
        userToken = result.value;
    }
});
let userEmail
userEmail = Office.context.mailbox.userProfile.emailAddress;

var attachments = Office.context.mailbox.item.attachments;
for (var i = 0; i < attachments.length; i++) {
    attachments[i] = JSON.parse(JSON.stringify(attachments[i]));
  }
//console.log(attachments);


const [emailA, setEmail] = useState('');

const confirmEmailChange = () => {
   const url =  apiUrl + '/api/Outlook';
   const akey = localStorage.getItem('authKey');
   if (akey != ""){
    Office.context.mailbox.item.body.getAsync(
        'text', 
        function (result) {
            if(emailAddy == ""){
                getPeoplePickerItem();
            }
            $.ajax({
                url: url,
                type: 'POST',
                contentType: "application/json",
                data: JSON.stringify({
                    authKey: akey,
                    userToken: userToken,
                    from: emailAddy,
                    subject: fromClient.subject,
                    content: result.value,
                    dateLogged: fromClient.dateTimeCreated                    
                }),
                success: function (response) {
                    setShowStatements(true); 
                    setTimeout(() => {
                        setShowStatements(false);
                    }, 3000);                     
                },
                error: function (response) {
                  setShowError(true);
                  setTimeout(() => {
                    setShowError(false);
                    }, 3000);              
                }
            });
            }
    );
   }
};

let allStatements
let errorStatement
let authStatement
let autherrorStatement



  if (setEmail) {
    emailAddy = emailA;
  }

  if (showStatements) {
      if (emailA){
        allStatements = <MessageBar role="alert">Email logged for {emailA}!</MessageBar>  
      }
      else{
        allStatements = <MessageBar role="alert">Email logged for {fromClient.from.emailAddress}!</MessageBar>  
      }
      
  }
  if (showErrors){
    if (emailA){
        errorStatement = <MessageBar messageBarType={MessageBarType.error} role="alert">Email {emailA} not found in AdvisorConX! Remove e-mail and retry.</MessageBar>
        
    }else{
        errorStatement = <MessageBar messageBarType={MessageBarType.error} role="alert">Email {fromClient.from.emailAddress} not found in AdvisorConX! Remove e-mail and retry.</MessageBar>
    }  
   }
  if (showPicker) {
        authStatement = <MessageBar role="alert">Authenticated!</MessageBar> 
  }
  if (showErrorAuth){
    autherrorStatement = <MessageBar messageBarType={MessageBarType.error} role="alert">Authentication error!</MessageBar>
   }  

    return (
        <div>
        { showPicker ? <div>
          <Label>1. It will search based on email address (that is already stored in AdvisorConX)</Label>
          <Label>or</Label>
          <Label>2. You can delete the email &#38; search by First Name or Company Name</Label>
          <Label>Once you have located the contact, you can “Log email in AX”.</Label>

        </div> : null}
        { showPicker ? <h3>Search your clients</h3> : null}
        {authStatement}
       { showPicker ? 
      <CompactPeoplePicker
        onResolveSuggestions={onFilterChanged}
        onEmptyInputFocus={returnMostRecentlyUsed}
        getTextFromItem={getTextFromItem}
        className={'ms-PeoplePicker'}
        defaultSelectedItems={fromFiltClient}
        key={'list'}
        selectionAriaLabel={'Selected contacts'}
        removeButtonAriaLabel={'Remove'}
        pickerSuggestionsProps={suggestionProps}
        onRemoveSuggestion={onRemoveSuggestion}
        onValidateInput={validateInput}
        componentRef={picker}
        resolveDelay={300}
        disabled={isPickerDisabled}
        onBlur={getPeoplePickerItem}
        inputProps={{autoComplete: 'yes'}}
      /> : null }
        { showPicker ? <ActionButton allowDisabledFocus iconProps={{ iconName: "Send" }} onClick={confirmEmailChange}>Log email in AX</ActionButton> : null}
        {allStatements}
        {errorStatement} 
      
        { !showPicker ? <Authentication /> : null }
        { !showPicker ? <button onClick={authUser}>Authenticate</button>: null }
        {autherrorStatement}
       
        <div style={{marginTop:"30px"}}>
            <Label>If you are having difficulty with your link to AdvisorConX, please use “Clear Key” and generate a new API Key from the AdvisorConX Outlook Add In page</Label>
            <br />
            <button onClick={clearStorage}>Clear key</button>
        </div>
     
      
     
    <div style={{visibility:"hidden"}}>
      <Checkbox
        label="Delay Suggestion Results"
        defaultChecked={delayResults}
        // eslint-disable-next-line react/jsx-no-bind
        onChange={onToggleDelayResultsChange}
        styles={checkboxStyles}
        checked="checked"/>
      </div>
    </div>
    
    );
};
export default PeoplePicker;

function clearStorage(){
    localStorage.clear();
}
function doesTextStartWith(text, filterText) {
    return text.toLowerCase().indexOf(filterText.toLowerCase()) === 0;
}
function removeDuplicates(personas, possibleDupes) {
    return personas.filter(persona => !listContainsPersona(persona, possibleDupes));
}
function listContainsPersona(persona, personas) {
    if (!personas || !personas.length || personas.length === 0) {
        return false;
    }
    return personas.filter(item => item.text === persona.text).length > 0;
}
function convertResultsToPromise(results) {
    return new Promise((resolve, reject) => setTimeout(() => resolve(results), 2000));
}
function getTextFromItem(persona) {
    return persona.text;
}
function validateInput(input) {
    if (input.indexOf('@') !== -1) {
        return ValidationState.valid;
    }
    else if (input.length > 1) {
        return ValidationState.warning;
    }
    else {
        return ValidationState.invalid;
    }
}
/**
 * Takes in the picker input and modifies it in whichever way
 * the caller wants, i.e. parsing entries copied from Outlook (sample
 * input: "Aaron Reid <aaron>").
 *
 * @param input The text entered into the picker.
 */
function onInputChange(input) {
    const outlookRegEx = /<.*>/g;
    const emailAddress = outlookRegEx.exec(input);
    if (emailAddress && emailAddress[0]) {
        return emailAddress[0].substring(1, emailAddress[0].length - 1);
    }
    return input;
}